import { CompanyProfessionals, SchedulingUnitsProvider } from '../modules/scheduling/index.js';
import { ChooseSchedulingUnit } from './choose-scheduling-unit.js';
import { useCompanyScope } from './company-context.js';
import { GatedCompanyScreen } from './gated-company-screen.js';
import type { ProfessionalsView } from './list-views.js';
import type { ViewSetter } from './view-state.js';

/// Profissionais em tela própria (ADR 0083). Mesma contratação e mesmas permissões da Agenda, e o
/// mesmo pedido de unidade: o cadastro pertence a um estabelecimento (ADR 0039).
export function CompanyProfessionalsScreen({
  view,
  onView,
}: {
  view: ProfessionalsView;
  onView: ViewSetter<ProfessionalsView>;
}) {
  const { can, timeZone, today, company } = useCompanyScope();
  const units = (company.businessUnits ?? []).filter((unit) => unit.kind !== 'SUPPORT');
  const activeBusinessUnitId = company.activeBusinessUnitId ?? null;
  const activeUnit = (company.businessUnits ?? []).find((unit) => unit.id === activeBusinessUnitId);
  return (
    <GatedCompanyScreen allowed={can('scheduling.read')}>
      {activeUnit?.kind === 'SUPPORT' ? (
        <ChooseSchedulingUnit
          subject="professionals"
          units={units}
          reason={`${activeUnit.displayName} é uma unidade de apoio e não tem profissionais. Escolha um estabelecimento.`}
        />
      ) : (company.businessUnits ?? []).length > 1 && activeBusinessUnitId === null ? (
        <ChooseSchedulingUnit
          subject="professionals"
          units={units}
          reason="Cada unidade tem os próprios profissionais. Escolha em qual unidade você vai trabalhar."
        />
      ) : (
        <SchedulingUnitsProvider
          value={{
            units,
            activeBusinessUnitId,
            commissionsEnabled: company.featureKeys.includes('sales.commissions'),
            canRegisterAdvances: can('sales.commissions.close'),
            today,
          }}
        >
          <CompanyProfessionals
            canManage={can('scheduling.resources.manage')}
            timeZone={timeZone}
            view={view}
            onView={onView}
          />
        </SchedulingUnitsProvider>
      )}
    </GatedCompanyScreen>
  );
}
